import { render, staticRenderFns } from "./AppLogo.vue?vue&type=template&id=5ab24d1b&scoped=true&"
import script from "./AppLogo.vue?vue&type=script&lang=js&"
export * from "./AppLogo.vue?vue&type=script&lang=js&"
import style0 from "./AppLogo.vue?vue&type=style&index=0&id=5ab24d1b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab24d1b",
  null
  
)

export default component.exports